<template>
  <div class="myHead-warpper" :style="{background: 'url(' + (detailBgImage?detailBgImage:bgImage) + ') no-repeat center center'}">
    <div class="myHead">
        <div class="logoBox"  v-show="isShowLogo" @click="handleClick" :style="{backgroundImage: 'url(' + (logo) + ')', backgroundSize:'100% 100%'}"></div>
        <a class="logoBox" :href="item.address" v-for="item in advLogoList" :key="item.id"  :style="{backgroundImage: 'url(' + (item.image) + ')', backgroundSize:'100% 100%'}"></a>
    </div>
    <div :class="back?'flexBox':'flexBox flexBox-center'"  v-if="mytitle  ">
      <div class="leftBox iconBox" v-if="back">
        <van-icon name="arrow-left" size="25px"  @click="handleBack"/>
      </div>
      <div class="centerBox">
          <div class="title">{{mytitle}}</div>
          <div class="subtitle">{{subtitle}}</div>
      </div>
      <div class="rightBox iconBox" v-if="back"></div>
    </div>
    <slot name="carousel" ></slot>
  </div>
</template>
<script>
import { Icon } from 'vant';
import { pageSetting, GetmatchTables, GetMatchHeader } from "@/request/api";

export default {
  name: 'myHead',
  data() {
    return {
      resTitle:"",
      logo:"",
      bgImage:"",
      id: "",
      advLogoList: [],
      detailBgImage: ''
    };
  },
  props: ['back', 'title', 'subtitle', 'getMatchHeaderId', 'isShowLogo'],
  components: {
    [Icon.name]: Icon,
  },
  computed:{
    mytitle:function(){
      return this.title?this.title:this.resTitle
    } 
  },
  mounted() {
    pageSetting().then(res => {
      if (res.success) {
        this.resTitle=res.data.name
        this.logo = res.data.logo;
        this.bgImage = res.data.bgImage;
        this.$emit('getFooter', res.data.footer)
      }
    });
    // this.GetmatchTables();
    this.GetMatchHeader();
  },
  methods: {
    // GetmatchTables(){
    //   this.advLogoList = [];
    //   GetmatchTables(this.$route.params.id).then(res => {
    //     if (res.success && res.data.topLogos.length) {
    //      for (let i=0; i < res.data.topLogos.length; i++){
    //         this.advLogoList.push(res.data.topLogos[i])
    //       }
    //     }
    //   })
    // },
    
     GetMatchHeader(){
      this.advLogoList = [];
      if (this.getMatchHeaderId) {
        GetMatchHeader(this.getMatchHeaderId).then(res => {
          this.detailBgImage = res.data.bgImage
          if (res.success && res.data.topLogos.length) {
          for (let i=0; i < res.data.topLogos.length; i++){
              this.advLogoList.push(res.data.topLogos[i])
            }
          }
        })
      }
     
    },
    handleClick(){
      console.log(this.$route)
      if(this.$route.path!="/"){
      this.$router.push({
        name: 'Home'
      })
      }

    },
    handleBack() {
      console.log(this);
      this.$emit('goBack', '');
    },
    
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.myHead-warpper {
  width: 100%;
  color: white;
  height: 225px;
  position: relative;
  background-size: cover!important;
  background-repeat: no-repeat;
  // background-size: 100%;
  // background-position: center -85%;
  .myHead{
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    .logoBox {
      display: inline-block;
        background:url('../assets/images/logo.png') no-repeat center;
        background-size: 100% 100%;
        width: 100px;
        height: 100px;
        margin-bottom:80px;
    }
  }
  .flexBox {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(0,0,0,0.75);
    .centerBox{
        text-align: center;
        .title{
            font-size: 20px;
        }
        .subtitle{
            font-size: 14px;
        }
    }
  }
  .flexBox-center{
      justify-content: center;
  }
  .iconBox {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
      &:hover{
      cursor:pointer
  }
  }
}
@media screen and (min-width: 768px) {
  // .myHead-warpper{
  //   background-size: 100% auto;
  //   background-position: center;
  // }
  .logoBox{
    width: 100px;
    height: 100px;
    margin-bottom:80px;
}
}
@media screen and (min-width: 920px) {
  .myHead-warpper {
  background-position: center 95%;
  }
}

</style>
